




























import Vue from 'vue';
import Component from 'vue-class-component';
import { getStatusFilter } from '@/modules/tickets/dashboard/store/tickets-dashboard.functions';
import { mapMutations } from 'vuex';
import { TicketStatus } from '@/modules/shared/shared/domain/constants/constants';
import { Tickets } from '@/modules/shared/shared/domain/constants/constants';
import { TicketDataTable } from '@/components/tickets/index';

@Component({
    components: {
        TicketDataTable,
    },
    methods: {
        ...mapMutations('layout', ['changeTitle']),
    },
})
export default class TicketsDayco extends Vue {
    limitTicketsDayco: number = 20;
    pageTicketsDayco: number = 1;
    filters: { id: number; name: string; type: string; color: string }[] = [];
    headersTicketsDayco: {}[] = [
        { text: 'Ticket', value: 'serial', align: 'end', sortable: false },
        { text: 'Cliente', value: 'customer', align: 'start', sortable: false },
        { text: 'Descripción', value: 'type', align: 'start', sortable: false },
        { text: 'Fecha', value: 'date', align: 'start', sortable: false },
        { text: 'Estatus', value: 'state', align: 'start', sortable: false },
    ];

    mounted() {
        //@ts-ignore
        this.changeTitle({ title: 'Histórico', route: ['TICKETS'] });
        this.$store.dispatch('getTicketsDayco', {
            limit: this.limitTicketsDayco,
            start: this.pageTicketsDayco,
        });
    }

    getItemsPerPage(value: number) {
        this.limitTicketsDayco = value;
        this.pageTicketsDayco = 1;
        if (this.filters.length < 1) {
            this.$store.dispatch('getTicketsDayco', {
                limit: this.limitTicketsDayco,
                start: this.pageTicketsDayco,
            });
        } else {
            this.getFiltersTicketMenu(this.filters);
        }
    }

    getFiltersTicketMenu(data: { id: number; name: string; type: string; color: string }[]) {
        this.filters = data;
        let type: string = '';
        let statusFilters: {
            open: string;
            solve: string;
            close: string;
        } = getStatusFilter(this.$store.state.filters);
        let status: string = '';
        let date: string[] = [];
        let startDate: string = '';
        let endDate: string = '';
        if (!data !== undefined) {
            for (let index = 0; index < data.length; index++) {
                if (data[index].type == 'T') {
                    if (type == '') {
                        type = '&ticketType=' + data[index].id;
                    } else {
                        type = type + '&ticketType=' + data[index].id;
                    }
                } else if (data[index].type == 'E') {
                    if (data[index].id == 1) {
                        status = status + statusFilters.open;
                    } else if (data[index].id == 7) {
                        status = status + statusFilters.solve;
                    } else if (data[index].id == 2) {
                        status = status + statusFilters.close;
                    }
                } else if (data[index].type == 'D') {
                    date = data[index].name.split(' ', 3);
                    startDate = '&startDate=' + date[0];
                    endDate = '&endDate=' + date[2];
                }
            }
            this.$store.dispatch('getTicketsByFilter', {
                customerid: '',
                limit: this.limitTicketsDayco,
                start: this.pageTicketsDayco,
                type: type,
                status: status,
                startDate: startDate,
                endDate: endDate,
            });
        } else {
            this.$store.dispatch('getTicketsDayco', {
                limit: this.limitTicketsDayco,
                start: this.pageTicketsDayco,
            });
        }
    }

    changePageTicketsDayco() {
        if (this.filters.length < 1) {
            this.$store.dispatch('getTicketsDayco', {
                limit: this.limitTicketsDayco,
                start: this.pageTicketsDayco,
            });
        } else {
            this.getFiltersTicketMenu(this.filters);
        }
    }

    get tickets() {
        if (this.$store.state.ticketsDayco.results !== undefined) {
            const auxTickets: {
                serial: number;
                customer: string;
                type: string;
                date: string;
                state: { name: string; color: string };
            }[] = [];
            for (let index = 0; index < this.$store.state.ticketsDayco.results.length; index++) {
                let type;
                if (
                    this.$store.state.ticketsDayco.results[index].typing.id ==
                        Tickets.ACCESS.typings.first_access_typing ||
                    this.$store.state.ticketsDayco.results[index].typing.id ==
                        Tickets.ACCESS.typings.second_access_typing
                ) {
                    type = this.$store.state.ticketsDayco.results[index].name;
                    if (
                        this.$store.state.ticketsDayco.results[index].accessPermission &&
                        this.$store.state.ticketsDayco.results[index].accessPermission
                            .accessPermissionMotives[0]
                    ) {
                        type = this.$store.state.ticketsDayco.results[index].accessPermission
                            .accessPermissionMotives[0].accessPermissionTypeMotive.accessType.name;
                    } else {
                        type = 'Ticket de Acceso';
                    }
                } else if (
                    [
                        2148,
                        2149,
                        2150,
                        20028,
                        2152,
                        2153,
                        2154,
                        20027,
                        2156,
                        2157,
                        2159,
                        2158,
                        2161,
                        2162,
                        2163,
                        20026,
                    ].includes(this.$store.state.ticketsDayco.results[index].typing.id)
                ) {
                    type = `${this.$store.state.ticketsDayco.results[index].typing.name} ${this.$store.state.ticketsDayco.results[index].typing.typing.name}`;
                } else {
                    type = this.$store.state.ticketsDayco.results[index].typing.name;
                }

                auxTickets.push({
                    serial: this.$store.state.ticketsDayco.results[index].id,
                    customer: this.$store.state.ticketsDayco.results[index].customer.name,
                    type,
                    date: this.setFormatDate(
                        this.$store.state.ticketsDayco.results[index].creationDate,
                    ),
                    state: {
                        name: this.setStatus(
                            this.$store.state.ticketsDayco.results[index].status.name,
                        ).value,
                        color: this.setStatus(
                            this.$store.state.ticketsDayco.results[index].status.name,
                        ).color,
                    },
                });
            }
            return auxTickets;
        } else {
            return [];
        }
    }

    get pagesTicketsDayco() {
        if (this.$store.state.ticketsDayco.pages !== undefined) {
            return this.$store.state.ticketsDayco.pages;
        } else {
            return 1;
        }
    }

    setFormatDate(fulldate: string) {
        const date: any = new Date(fulldate);
        let year: any = date.getFullYear();
        let month: any = date.getMonth() + 1;
        let dt: any = date.getDate();

        if (dt < 10) {
            dt = '0' + dt;
        }
        if (month < 10) {
            month = '0' + month;
        }
        return dt + '/' + month + '/' + year;
    }

    setStatus(value: string) {
        if (value == TicketStatus.FIXED) {
            return { value: value, color: 'amber' };
        } else if (value == TicketStatus.CLOSED || value == 'Cerrado' || value === 'Finalizado') {
            return { value: TicketStatus.CLOSED, color: 'cyan' };
        } else {
            return { value: TicketStatus.OPENED, color: 'pink' };
        }
    }
}
